<p-table #table class="small-text-table" [value]="messages" [rows]="10" [responsive]="true">
    <ng-template pTemplate="body" let-message let-index="rowIndex">
        <tr class="clickable-row" (click)="goToNotification(message.id)">
            <td>{{message.title}}</td>
            <td>{{ message.messageTime | date:'MM/dd/yy HH:mm:ss z' }}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-message let-index="rowIndex">
        <tr>
            <td>You have no unread notifications.</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-message let-index="rowIndex">
        <tr *ngIf="hasExtraMessages$ | async">
            <td  colspan="2">There are more than 10 unread messages.</td>
        </tr>
        <tr>
            <td colspan="2">Click <a href="/notifications">here</a> to view all notifications.</td>
        </tr>
    </ng-template>
</p-table>